import { render, staticRenderFns } from "./GraficoNivelPovoamentoEstrato.vue?vue&type=template&id=83634f7e"
import script from "./GraficoNivelPovoamentoEstrato.vue?vue&type=script&lang=js"
export * from "./GraficoNivelPovoamentoEstrato.vue?vue&type=script&lang=js"
import style0 from "./GraficoNivelPovoamentoEstrato.vue?vue&type=style&index=0&id=83634f7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports